import React from "react";
import EventCardSkeleton from "./EventCardSkeleton";
import BusinessCardSkeleton from "./BusinessCardSkeleton";
import CardSkeleton from "./CardSkeleton";

function SearchSkeleton({ dataPage }) {
  return (
    <div className="row">
      {Array.from({ length: 6 }).map((_, index) => (
        <div className={dataPage === "property" ? "col-lg-6 col-md-6 col-sm-12" : dataPage === "job" ? "col-lg-12 col-md-12 col-sm-12" : dataPage === "business" || dataPage === "event" ? "col-lg-6 col-md-6 col-sm-12" : "col-lg-6 col-md-6 col-sm-12"} key={`skeleton-${index}`}>
          {dataPage === "event" && <EventCardSkeleton />}
          {dataPage === "business" && <BusinessCardSkeleton />}
          {dataPage === "property" && <CardSkeleton />}
          {dataPage === "job" && <CardSkeleton />}
        </div>
      ))}
    </div>
  );
}

export default SearchSkeleton;
